import * as React from 'react';
import { SVGProps } from 'react';
import { success } from '../../definitions/colors';
const SvgUserCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13.9 5.6c-1.1 0-2.1.2-3.1.6 0 2.5-2 4.5-4.5 4.6-.4.9-.5 1.9-.5 3 0 4.5 3.6 8.1 8.1 8.1 4.6 0 8.1-3.6 8.1-8.1s-3.6-8.1-8.1-8.1Zm-.1 2.3c1.9 0 3.6 1.5 3.5 3.4 0 1.9-1.5 3.5-3.4 3.6-1.9 0-3.5-1.5-3.5-3.5 0-1.9 1.6-3.5 3.4-3.5Zm5.7 10c-.4.6-.9 1.1-1.5 1.5-.7.5-1.5.9-2.4 1.1-.6.2-1.1.2-1.8.2-1.6 0-3.1-.6-4.4-1.6-.4-.4-.8-.8-1.2-1.3v-.1c.1-.8.3-1.5.8-2.2.4-.6.9-1 1.6-1.1h.2c.5.5 1 .9 1.7 1.1.7.3 1.5.3 2.2.2.9-.2 1.7-.6 2.4-1.3h.2c.7.1 1.2.5 1.6 1.1.4.7.7 1.5.8 2.3v.1Z" />
    <path
      d="M5.9 2.1c2.2 0 3.9 1.8 3.9 3.9 0 2.2-1.8 3.9-3.9 3.9C3.7 9.9 2 8.2 2 6s1.7-3.9 3.9-3.9Zm-.4 4.5L4.4 5.5c-.2-.2-.4-.2-.5 0l-.4.4c-.2.1-.2.4 0 .5l1.8 1.8c.2.2.4.2.6 0l.9-.9 1.8-1.8c.2-.2.2-.4 0-.5l-.5-.5h-.4l-.1.1-1.3 1.3-.7.7Z"
      style={{
        fill: success[500],
      }}
    />
  </svg>
);
export default SvgUserCheck;
